import React from "react";
import { Link } from "gatsby";
import wechatJpg from "../../assets/images/common/wechat.jpg";

const ConsultBar = ({ scrollStepInPx, delayInMs }) => {
  const online_consult_url =
    // "https://p.qiao.baidu.com/cps/chat?siteId=20883174&userId=57472853&siteToken=b7760058a759635c7f463de978f71a85";
    "https://affim.baidu.com/unique_57472853/chat?siteId=20883174&userId=57472853&siteToken=b7760058a759635c7f463de978f71a85";

  const [thePosition, setThePosition] = React.useState(false);
  const timeoutRef = React.useRef(null);

  React.useEffect(() => {
    document.addEventListener("scroll", () => {
      if (window.scrollY > 370) {
        setThePosition(true);
      } else {
        setThePosition(false);
      }
    });
  }, []);

  const onScrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(timeoutRef.current);
    }
    window.scroll(0, window.pageYOffset - scrollStepInPx);
  };

  const scrollToTop = () => {
    timeoutRef.current = setInterval(onScrollStep, delayInMs);
  };

  const renderGoTopIcon = () => {
    return (
      <div class="consult-bar">
        <a class="consult-button" href={online_consult_url} target="_blank">
          <span class="icon">
            <i class="bx bx-message"></i>
          </span>
          <span class="name">
            在线
            <br />
            咨询
          </span>
        </a>
        <a href="tel:400-028-5267" class="consult-button">
          <span class="icon">
            <i class="bx bx-phone-call"></i>
          </span>
          <span class="name">
            电话
            <br />
            咨询
          </span>
          <div class="phone-block">
            <p>服务热线</p>
            <p class="text-success">400-028-5267</p>
          </div>
        </a>
        <div class="consult-button">
          <span class="icon">
            <i class="iconfont icon-weixin"></i>
          </span>
          <span class="name">
            微信
            <br />
            咨询
          </span>
          <div class="weixin-block">
            <img src={wechatJpg} alt="联系二维码" />
          </div>
        </div>
        <Link to="/reservation" className="consult-button">
          <span class="icon">
            <i class="bx bx-slideshow"></i>
          </span>
          <span class="name">
            预约
            <br />
            演示
          </span>
        </Link>
        <div className={`consult-button back-to-top ${thePosition ? "active" : ""}`} onClick={scrollToTop}>
          <i className="flaticon-up"></i>
        </div>
      </div>
    );
  };

  return <React.Fragment>{renderGoTopIcon()}</React.Fragment>;
};

export default ConsultBar;
